import { render, staticRenderFns } from "./EventComponent.vue?vue&type=template&id=575b970b&scoped=true"
import script from "./EventComponent.vue?vue&type=script&lang=js"
export * from "./EventComponent.vue?vue&type=script&lang=js"
import style0 from "./EventComponent.vue?vue&type=style&index=0&id=575b970b&prod&lang=scss"
import style1 from "./EventComponent.vue?vue&type=style&index=1&id=575b970b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575b970b",
  null
  
)

export default component.exports